import type { CosmosData, GalaxyKey } from "../parser/types.ts";

export interface HudCallbacks {
  onToggleGalaxy: (g: GalaxyKey, active: boolean) => void;
}

/** Chrome de UI (DOM) sobreposto ao canvas: marca, legenda, busca, título de foco. */
export class Hud {
  private focusEl!: HTMLDivElement;

  constructor(private data: CosmosData, private cb: HudCallbacks) {}

  mount(root: HTMLElement) {
    root.insertAdjacentHTML("beforeend", `
      <div id="brand" class="panel fade">
        <div class="t"><span class="orb"></span><h1>JHONE&nbsp;HQ&nbsp;·&nbsp;<span class="sub">COSMOS</span></h1></div>
        <p>O universo operacional do JHONE HQ. No centro, o Strategic Council — o Sol que governa tudo. Ao redor, as galáxias do ecossistema.</p>
      </div>
      <div id="legend" class="panel fade"></div>
      <button id="help-btn" class="panel" title="Atalhos (?)">?</button>
      <div id="focusTitle"></div>
    `);
    (root.querySelector("#help-btn") as HTMLElement).addEventListener("click", () =>
      document.getElementById("help")?.classList.toggle("open"));

    const legend = root.querySelector("#legend")!;
    const active: Record<string, boolean> = {};
    for (const [g, meta] of Object.entries(this.data.gal)) {
      if (g === "council") continue; // o Sol é sempre visível
      active[g] = true;
      const row = document.createElement("div");
      row.className = "row";
      row.innerHTML = `<span class="dot" style="background:${meta.color};color:${meta.color}"></span>${meta.label}`;
      row.addEventListener("click", () => {
        active[g] = !active[g];
        row.classList.toggle("dim", !active[g]);
        this.cb.onToggleGalaxy(g as GalaxyKey, active[g]);
      });
      legend.appendChild(row);
    }

    this.focusEl = root.querySelector<HTMLDivElement>("#focusTitle")!;
  }

  refresh(data: CosmosData) { this.data = data; }

  setFocusTitle(gal: GalaxyKey | null) {
    const el = this.focusEl;
    if (gal && this.data.gal[gal]) {
      el.textContent = "✦ " + this.data.gal[gal].label;
      el.style.color = this.data.gal[gal].color;
      el.style.opacity = "1";
      el.style.transform = "translateX(-50%) translateY(0)";
    } else {
      el.style.opacity = "0";
      el.style.transform = "translateX(-50%) translateY(-8px)";
    }
  }
}
